import { supabase } from '../lib/supabase';

export const analyticsService = {
  async getPlatformStats() {
    const { data, error } = await supabase
      .from('platform_stats')
      .select('*')
      .order('stats_date', { ascending: false })
      .limit(1)
      .maybeSingle();

    if (error) throw error;
    return data;
  },

  async trackDownload(platform: string) {
    const { error } = await supabase.from('download_analytics').insert({
      platform,
      user_agent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    });

    if (error) throw error;
  },

  async getDownloadStats(days = 30) {
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - days);

    const { data, error } = await supabase
      .from('download_analytics')
      .select('platform, created_at')
      .gte('created_at', startDate.toISOString())
      .order('created_at', { ascending: false });

    if (error) throw error;

    const stats = data?.reduce((acc: any, curr) => {
      acc[curr.platform] = (acc[curr.platform] || 0) + 1;
      return acc;
    }, {});

    return {
      total: data?.length || 0,
      byPlatform: stats || {},
      data: data || [],
    };
  },

  async getCollectionStats(userId: string) {
    const { data, error } = await supabase
      .from('collections')
      .select('actual_cans, deposit_amount, collection_date')
      .eq('collector_id', userId)
      .order('collection_date', { ascending: false });

    if (error) throw error;

    const totalCans = data?.reduce((sum, c) => sum + c.actual_cans, 0) || 0;
    const totalDeposit = data?.reduce((sum, c) => sum + c.deposit_amount, 0) || 0;
    const totalCollections = data?.length || 0;

    return {
      totalCans,
      totalDeposit,
      totalCollections,
      collections: data || [],
    };
  },

  async getRecentActivity(userId: string, limit = 10) {
    const { data, error } = await supabase
      .from('pickup_requests')
      .select(`
        *,
        household:profiles!pickup_requests_household_id_fkey(full_name),
        collector:profiles!pickup_requests_collector_id_fkey(full_name)
      `)
      .or(`household_id.eq.${userId},collector_id.eq.${userId}`)
      .order('created_at', { ascending: false })
      .limit(limit);

    if (error) throw error;
    return data;
  },
};
